import Button from "@mui/material/Button";
import React from "react";

export const RemoveButton = ({ handleClick, mobile }) => {
  return (
    <Button
      onClick={handleClick}
      variant="contained"
      sx={{
        backgroundColor: "#e6003d",
        borderRadius: mobile ? "4px" : "10px",
        height: mobile ? "26px" : "40px",
        color: "white",
        textTransform: "none",
        paddingLeft: "30px",
        paddingRight: "30px",
        width: "80%",
        margin: "4px 0",
        "&:active": {
          backgroundColor: "#243046",
          boxShadow: "none",
        },
        "&:hover": {
          backgroundColor: "#243046",
          boxShadow: "none",
        },
        boxShadow: "none",
        fontFamily: "proxima-nova, sans-serif",
        fontSize: mobile ? 12 : 14,
        fontWeight: 800,
      }}
    >
      Remove
    </Button>
  );
};
